module.exports = __webpack_public_path__ + "static/media/ts14cr93.79c4b694.png";